import { useEffect } from 'react';
import { getUsageTracker } from '../../utils/usage-tracker/index';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMetadata } from 'developer-docs-shared-components/hooks/useMetadata';
import Card from 'developer-docs-mdx-components/components/Card';
import I18n from 'I18n';
import H1 from 'developer-docs-shared-components/components/PublicH1';
import H2 from 'UIComponents/elements/headings/H2';
import { Illustration, Media, MediaBody, Right } from './sharedStyledComponents';
import UIIcon from 'UIComponents/icon/UIIcon';
import { EERIE } from 'HubStyleTokens/colors';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UIMedia from 'UIComponents/layout/UIMedia';
import { apiEndpointsNavConfig } from '../../config/nav/reference/apiEndpoints';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function GuidesLandingPage() {
  const titleParams = ['developer-docs-ui.htmlTitles.mdxDoc', {
    pageTopic: I18n.text('developer-docs-ui.navigation.guides.primaryNavLinkLabel')
  }];
  useMetadata({
    title: I18n.text(...titleParams),
    description: I18n.text('developer-docs-ui.metaDescriptions.guides'),
    isContentLoaded: true
  });
  // If there are named exports as well, *.default needs to be used

  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: 'guidesLandingPage',
      subscreen: 'guidesLandingPage'
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H1, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.guidesLandingPage.header"
      })
    }), /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.guidesLandingPage.intro.header"
      })
    }), /*#__PURE__*/_jsx(MediaBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.guidesLandingPage.intro.description"
      })
    }), /*#__PURE__*/_jsx(Card, {
      children: /*#__PURE__*/_jsxs(Media, {
        align: "center",
        children: [/*#__PURE__*/_jsxs(MediaBody, {
          children: [/*#__PURE__*/_jsx(H2, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.guidesLandingPage.quickLinks.header"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "m-bottom-8",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.guidesLandingPage.quickLinks.description"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "m-bottom-8",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-docs-ui.guidesLandingPage.quickLinks.relevantDocs"
            })
          }), /*#__PURE__*/_jsxs(UIMedia, {
            align: "center",
            className: "m-bottom-4",
            children: [/*#__PURE__*/_jsx(UIIcon, {
              name: "code",
              size: "medium",
              className: "m-right-3",
              color: EERIE
            }), /*#__PURE__*/_jsx(UIRouterLink, {
              to: apiEndpointsNavConfig().commonPath,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-docs-ui.guidesLandingPage.quickLinks.link"
              })
            })]
          })]
        }), /*#__PURE__*/_jsx(Right, {
          children: /*#__PURE__*/_jsx(Illustration, {
            name: "integrations"
          })
        })]
      })
    })]
  });
}
export default GuidesLandingPage;